import { AuthenticationTabs } from ".";

const AuthContent = () => {
	return (
		<main className="main flex-column align-center flex-gap-1">
			<AuthenticationTabs />
		</main>
	);
};
export { AuthContent };
